module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/meta-2-2020-desktop.jpg?v=2d61ee02";